import React, { useEffect, useState } from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import Modal from "react-modal";
import { ReactComponent as CloseIcon } from "../../../assets/icons/CloseIcon.svg";
import "./SettingsStyles.css";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";
import { ReactComponent as AddIcon } from "../../../assets/icons/Add-Icon.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/Delete.svg";
import StatusPill from "../../common/StatusText";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchDefaultAssessmentsLogic,
  createAssessmentLogic,
  deleteAssessmentByIdLogic,
  fetchAssessmentTypesLogic,
} from "../../../store/features/patient/assessmentsSlice";
import PatientLoader from "../../common/PatientLoader";
import { gapDays } from "../../../constants/constants";
import { CBadge } from "@coreui/react";

const AssessmentModal = ({ modalIsOpen, setModalOpen, infoData }) => {
  Modal.setAppElement("#root");
  function closeModal(e) {
    e.preventDefault();
    setModalOpen(false);
  }
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel=""
      style={{
        overlay: {
          background: "rgba(0, 0, 0, 0.5)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          background: "#fff",
          border: "none",
        },
      }}
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="w-100 pt-2 d-flex justify-content-start">
            <h3 className="primary-text-blue" style={{ fontWeight: "500" }}>
              {infoData?.name}
            </h3>
          </div>
          <div className="row">
            <div
              className="col-sm-12 col-md-6 col-lg-6"
              style={{
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                padding: "10px",
              }}
            >
              <div
                className="container-fluid w-100 py-2"
                style={{ backgroundColor: "lightblue" }}
              >
                <h5>Questionnaire</h5>
              </div>
              <ul className="list-group">
                {infoData?.questionnaire?.map((item, index) => {
                  return (
                    <li className="list-group-item" key={index}>
                      {item?.sort}:{item?.text}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div
                className="container-fluid w-100 py-2"
                style={{ backgroundColor: "lightblue" }}
              >
                <h5>Answers</h5>
              </div>
              <div className="d-flex flex-row">
                <ul className="list-group">
                  {infoData?.answer_group?.answers?.map((item, index) => {
                    return (
                      <li className="list-group-item" key={index}>
                        {item?.sort}:{item?.text}-score:{item?.score}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div
                className="container-fluid w-100 py-2"
                style={{ backgroundColor: "lightblue" }}
              >
                <h5>Tags</h5>
              </div>
              <div className="d-flex flex-row">
                <ul className="list-group">
                  {infoData?.tag_group?.tags?.map((item, index) => {
                    return (
                      <li className="list-group-item" key={index}>
                        <CBadge color="info" shape="rounded-pill">
                          {item?.label}
                        </CBadge>
                        {"   "}
                        {item?.low_bound}-{item?.high_bound}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};
const AssessmentItem = ({ assessmentData, handleAssessmentActions }) => {
  const [modalIsOpen, setModalOpen] = useState(false);
  const [infoData, setInfoData] = useState({});
  const { assessmentTypes } = useSelector((state) => state.assessment);

  function toggleModal() {
    setModalOpen(!modalIsOpen);
  }
  function modalData() {
    const tempInfoData = assessmentTypes.find((item) => {
      return item.id == assessmentData?.assessment?.id;
    });
    setInfoData(tempInfoData);
  }
  useEffect(() => {
    modalData();
  }, []);
  return (
    <tr
      className="py-3"
      style={{
        height: "4rem",
        verticalAlign: "middle",
      }}
    >
      <td>
        <small className="muted-text" style={{ fontWeight: "500" }}>
          {assessmentData?.assessment?.name}
        </small>
      </td>
      <td style={{ width: "25%" }}>
        <StatusPill text="active" />
      </td>
      <td>
        <small className="muted-text" style={{ fontWeight: "500" }}>
          {assessmentData?.gap_days} days
        </small>
      </td>
      <td>
        <div className="d-flex justify-content-evenly" style={{ gap: "10px" }}>
          <button className="btn transparent-btn" onClick={toggleModal}>
            <InfoIcon />
            <AssessmentModal
              modalIsOpen={modalIsOpen}
              setModalOpen={toggleModal}
              infoData={infoData}
            />
          </button>

          <button
            className="btn transparent-btn"
            onClick={() => {
              handleAssessmentActions(assessmentData?.id, "delete");
            }}
          >
            <TrashIcon />
          </button>
        </div>
      </td>
    </tr>
  );
};

const DefaultAssessment = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.app);
  const { selectedClinic } = useSelector((state) => state.app);
  const {
    defaultAssessmentsLoading,
    defaultAssessmentData,
    assessmentTypes,
    createAssessmentLoading,
  } = useSelector((state) => state.assessment);
  const [assessmentNames, setAssesmentNames] = useState([]);
  const [assessmentSelectedValue, setAssessmentSelectedValue] = useState();
  const [gapDaysSelectedValue, setGapDaysSelectedValue] = useState();

  useEffect(() => {
    let clinicPin =  selectedClinic?.id || user?.clinic?.id
    dispatch(fetchDefaultAssessmentsLogic(clinicPin));
    dispatch(fetchAssessmentTypesLogic());
  }, [dispatch, user?.clinic?.id]);
  useEffect(() => {
    const tempAssesmentNames = assessmentTypes?.map((element) => {
      return { label: element.name, value: element.id };
    });
    setAssesmentNames(tempAssesmentNames);
  }, [assessmentTypes]);
  const handleAddingAssessment = () => {
    if (createAssessmentLoading) {
      return;
    }
    let payload = {
      assessment: assessmentSelectedValue,
      clinic_pin: selectedClinic?.id || user?.clinic?.id,
      gap_days: parseInt(gapDaysSelectedValue),
    };
    dispatch(createAssessmentLogic(payload));
  };
  const handleDeletingAssessment = (id) => {
    dispatch(deleteAssessmentByIdLogic(id));
  };

  const handleAssessmentActions = (id, action) => {
    if (action === "delete") {
      handleDeletingAssessment(id);
    }
  };
  const handleAssesmentSelected = (e) => {
    setAssessmentSelectedValue(e.value);
  };
  const handleGapDaysSelected = (e) => {
    setGapDaysSelectedValue(e.value);
  };
  return (
    <div className="container-fluid mb-5">
      <CardLayout>
        <div className="container-fluid d-flex justify-content-start w-100 py-3">
          <div className="container-fluid">
            <h5 className="muted-text">Default Assessments</h5>
            <br />
            <span>
              Set up the assessments that will be scheduled for all of your new
              Rose patients by default.
              <br />
              You can then customize these to individual patients on the
              patient's profile
            </span>
          </div>
        </div>
        {defaultAssessmentsLoading ? (
          <PatientLoader />
        ) : (
          <div className="container-fluid">
            <table className="table mt-3 px-2">
              <thead
                className="thead-light"
                style={{ backgroundColor: "#F9FAFB" }}
              >
                <tr
                  style={{
                    height: "4rem",
                    verticalAlign: "middle",
                  }}
                >
                  <th scope="col">
                    <small className="muted-text">Assessments</small>
                  </th>
                  <th scope="col">
                    <small className="muted-text">Status</small>
                  </th>
                  <th scope="col">
                    <small className="muted-text">Gap Days</small>
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    <small className="muted-text">Actions</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                {defaultAssessmentData?.length > 0 &&
                  defaultAssessmentData?.map((assessment) => {
                    return (
                      <AssessmentItem
                        assessmentData={assessment}
                        key={assessment?.id}
                        handleAssessmentActions={handleAssessmentActions}
                      />
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}

        <div className="container-fluid w-100 d-flex justify-content-start">
          <h5 className="muted-text">Add Additional Assessment</h5>
        </div>
        <div className="container-fluid w-100 d-flex justify-content-start">
          <div className="add-assesment-container">
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "20rem",
                  border: "0px",
                  borderRadius: "0px",
                  outline: "0px",
                  color: "#94A3B8 !important",
                  borderBottom: "1px solid #94A3B8 !important",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Select Assessment"
              classNamePrefix="select"
              name="add-assessment"
              options={assessmentNames}
              onChange={handleAssesmentSelected}
              value={assessmentNames.find(
                (e) => e.value === assessmentSelectedValue
              )}
            />
            <span
              className="muted-text"
              style={{ padding: "0px 10px", width: "20%", gap: "10px " }}
            >
              every
            </span>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "20rem",
                  border: "0px",
                  borderRadius: "0px",
                  outline: "0px",
                  color: "#94A3B8 !important",
                  borderBottom: "1px solid #94A3B8 !important",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Select Gap days"
              classNamePrefix="select"
              name="gap-days"
              options={gapDays}
              onChange={handleGapDaysSelected}
              value={gapDays.find((e) => e.value === gapDaysSelectedValue)}
            />
            <span className="muted-text" style={{ width: "20%", gap: "10px" }}>
              days
            </span>
            <button
              className="btn transparent-btn"
              onClick={() => {
                handleAddingAssessment();
              }}
              disabled={createAssessmentLoading}
            >
              <AddIcon fill="#fff" height={"1.5rem"} width={"1.5rem"} />
            </button>
          </div>
        </div>
      </CardLayout>
    </div>
  );
};

export default DefaultAssessment;
